import { Navigate, Route, Routes, Outlet } from "react-router-dom";
import UserSettings from "./UserSettings";
import ListMenu from "./ListMenu";
import CustomerSettings from "./CustomerSettings";
import EmailSettings from "./EmailSettings";
import TicketSettings from "./TicketSettings";
import GeneralSettings from "./GeneralSettings";
import CampaignSetting from "./CampaignSettings";
import ViewMessage from "../../components/settings/email/template/ViewMessage";
import TelephonySettings from "./TelephonySettings";
import Configuration from "./Configuration";
import ChatSettings from "./ChatSettings";
import YoutubeConfiguration from "./YoutubeConfiguration";
import InstagramConfiguration from "./InstagramConfiguration";
import InstagramConfigurationData from "./InstagramConfigurationData";

const SettingRoutes = () => {
  return (
    <section className="row mx-1">
      {/* <div className="card px-2 col-lg-2 border border-secondary rounded">
        <ListMenu />
      </div> */}
      <div
        className="card col ms-xl-6 d-flex flex-column mt-4 mt-lg-0"
        style={{ overflow: "hidden", height: "88vh" }}
      >
        <Routes>
          <Route path="users" element={<UserSettings />} />
          <Route path="customer" element={<CustomerSettings />} />
          <Route path="general" element={<GeneralSettings />} />
          <Route path="email" element={<EmailSettings />} />
          <Route path="/settings/email/:id" element={<ViewMessage />} />
          <Route path="ticket" element={<TicketSettings />} />
          <Route path="campaign" element={<CampaignSetting />} />
          <Route path="telephony/*" element={<TelephonySettings />} />
          <Route path="integration" element={<Configuration />} />
          <Route path="setting-chat" element={<ChatSettings />} />
          <Route path="youtube" element={<YoutubeConfiguration />} />
          <Route
            path="instagram"
            element={<InstagramConfiguration title="Instagram" />}
          />
          <Route
            path="website"
            element={<InstagramConfiguration title="Website" />}
          />
          <Route
            path="youtubebot"
            element={<InstagramConfiguration title="Youtube" />}
          />
          <Route
            path="instagram-config"
            element={<InstagramConfigurationData />}
          />
          <Route index element={<Navigate to="users" />} />
        </Routes>
      </div>
    </section>
  );
};

export default SettingRoutes;
